import { app } from "./flamelink";

export const getLatest = async ({ limit = 36, startAfter = null } = {}) => {
  const stories = await app.content.get({
    schemaKey: "story",
    fields: [
      "title",
      "slug",
      "thumbnailImage",
      "directoryCardThumbnailImage",
      "cardColour",
      "id",
      "_fl_meta_"
    ],
    populate: ["thumbnailImage", "directoryCardThumbnailImage"],
    ...(startAfter !== null && { startAfter }),
    limit,
    orderBy: [
      {
        field: "_fl_meta_.createdDate",
        order: "desc"
      }
    ]
  });

  return stories;
};

export const getBySlug = async slug => {
  const stories = await app.content.getByField({
    schemaKey: "story",
    field: "slug",
    value: slug,
    fields: ["body", "credits", "title"],
    populate: [
      {
        field: "body",
        // subFields key would be more appropriate for repeater field
        populate: [
          {
            field: "images",
            populate: [
              {
                field: "image"
              }
            ]
          },
          {
            field: "video"
          }
        ]
      }
    ]
  });

  return stories;
};
